import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const links = [
  { label: "Home", href: "https://wifi.com.ng/" },
  { label: "About Us", href: "https://wifi.com.ng/aboutus/" },
  { label: "Services", href: "https://wifi.com.ng/services/" },
  { label: "Pricing", href: "https://wifi.com.ng/newuser/" },
  { label: "Blog", href: "https://wifi.com.ng/blog/" },
  { label: "Signup", href: "https://wifi.com.ng/turboconnect/" },
  { label: "Login", href: "https://dashboard.tizeti.com/" },
  { label: "Contact Us", href: "http://wifi.com.ng/contact-us/" },
];

const LOGO =
  "https://res.cloudinary.com/teewhy/image/upload/v1562151644/WificomngLogo.png";

const MenuBar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-md shadow-sm">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-5 py-2 md:py-3">
        <Link to="/" className="shrink-0">
          <img
            src={LOGO}
            alt="Wifi.com.ng"
            className="h-14 sm:h-16 md:h-20 w-auto max-w-[180px] sm:max-w-[240px] object-contain"
          />
        </Link>

        <ul className="hidden lg:flex items-center gap-1">
          {links.map((link) => (
            <li key={link.label} className="group relative px-3 py-2">
              <a
                className="text-sm font-medium text-brand-dark/80 hover:text-brand-teal transition-colors no-underline"
                href={link.href}
              >
                {link.label}
              </a>
              <span className="absolute left-3 right-3 -bottom-0.5 h-0.5 origin-left scale-x-0 bg-brand-teal transition-transform duration-300 group-hover:scale-x-100" />
            </li>
          ))}
        </ul>

        <motion.button
          type="button"
          onClick={() => setOpen(!open)}
          whileTap={{ scale: 0.9 }}
          aria-expanded={open}
          aria-label="Toggle navigation"
          className="flex flex-col justify-center gap-1.5 p-2 lg:hidden"
        >
          <motion.span
            animate={open ? { rotate: 45, y: 6.5 } : { rotate: 0, y: 0 }}
            className="block h-0.5 w-6 bg-brand-dark origin-center"
          />
          <motion.span
            animate={open ? { opacity: 0 } : { opacity: 1 }}
            className="block h-0.5 w-6 bg-brand-dark"
          />
          <motion.span
            animate={open ? { rotate: -45, y: -6.5 } : { rotate: 0, y: 0 }}
            className="block h-0.5 w-6 bg-brand-dark origin-center"
          />
        </motion.button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="lg:hidden overflow-hidden border-t border-black/5"
          >
            <ul className="flex flex-col px-5 py-2">
              {links.map((link, i) => (
                <motion.li
                  key={link.label}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.04 }}
                  className="py-2 border-b border-black/5 last:border-0"
                >
                  <a
                    className="text-brand-dark/90 hover:text-brand-teal no-underline"
                    href={link.href}
                    onClick={() => setOpen(false)}
                  >
                    {link.label}
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default MenuBar;
